import type { ApiResponse } from "@/types/common";
import type { GetCategoryResponse, CategoryParams } from "@/types/category";
import { privateRequest } from "../axios";

const ENDPOINTS = {
    QUESTION_CATEGORIES: "/question-categories",
};

const getAllCategories = async (params?: CategoryParams): Promise<GetCategoryResponse> => {
    const response = await privateRequest.get<ApiResponse<GetCategoryResponse>>(
        ENDPOINTS.QUESTION_CATEGORIES,
        { params },
    );
    return {
        totalRecord: response?.data?.data?.totalRecord ?? 0,
        results: response?.data?.data?.results ?? [],
    };
};

const CategoryService = {
    getAllCategories,
};

export default CategoryService;